const getMemberReferenceId = (reference) => {
  if (reference && typeof reference === 'object') {
    return reference.id ?? reference.hac_id ?? reference.hacId ?? null;
  }

  return reference ?? null;
};

export function getCalendarMemberReferences(task) {
  const assignedMembers = [
    task?.assigned_hacs,
    task?.assignedHacs,
    task?.hacs,
    task?.tags,
  ].find((value) => Array.isArray(value) && value.length > 0) ?? [];
  const uniqueReferences = new Map();

  assignedMembers.forEach((reference) => {
    const id = getMemberReferenceId(reference);
    if (id === null || id === undefined || String(id).trim() === '') return;

    const normalizedId = String(id);
    if (!uniqueReferences.has(normalizedId)) uniqueReferences.set(normalizedId, reference);
  });

  return Array.from(uniqueReferences.values());
}

export function getCalendarMemberIds(task) {
  return getCalendarMemberReferences(task).map((reference) => String(getMemberReferenceId(reference)));
}

export function getCalendarMemberReferenceId(reference) {
  const id = getMemberReferenceId(reference);
  return id === null || id === undefined ? null : String(id);
}
